
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Home } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { language } = useLanguage();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
    
    // Automatic redirect countdown
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate("/");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    
    return () => clearInterval(timer);
  }, [location.pathname, navigate]);

  const goHome = () => {
    navigate("/");
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-noa-antiflash-white px-4 text-center">
      <div className="max-w-md mx-auto bg-white p-8 rounded-lg shadow-lg">
        <h1 className="text-6xl font-bold text-noa-rich-black mb-4">404</h1>
        <p className="text-xl text-noa-charcoal mb-6">
          {language === 'en' ? 'Page not found' : 'Página no encontrada'}
        </p>
        <p className="text-noa-slate-gray mb-8">
          {language === 'en' 
            ? `The page you are looking for does not exist or has been moved. You will be redirected to the home page in ${countdown} seconds.`
            : `La página que estás buscando no existe o ha sido movida. Serás redirigido a la página principal en ${countdown} segundos.`}
        </p>
        <Button
          onClick={goHome}
          className="bg-noa-rich-black text-white hover:bg-noa-charcoal inline-flex items-center gap-2"
        >
          <Home size={18} />
          {language === 'en' ? 'Back to Home' : 'Volver al Inicio'}
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
